<template>
    <div class="tw:pt-6 tw:pb-4 tw:mt-auto tw:flex tw:justify-center">
        <span>© {{ currentYear }} Stanbridge University</span>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import moment from '@/plugins/vue-moment.js';

const currentYear = computed(() => {
    return moment().year();
});
</script>
